import React from "react";
import { NavLink } from "react-router-dom";
import { plus } from "../../assets/icons";
import { useSelector } from "react-redux";

export default function Navigation({ onLinkClick }) {

	const { user } = useSelector(state => ({ user: state.session.user }));

	const links = user ? [
		{
			name: "Account Summary",
			path: "/me",
		},
		{
			name: "My Purchases",
			path: "/me/orders",
		},
		user.shop && {
			name: "spacer",
		},
		user.shop && {
			name: "Shop Details",
			path: "/me/shop",
		},
		user.shop && {
			name: "Shop Products",
			path: "/me/shop/products",
		},
		user.shop && {
			name: "Shop Add-ons",
			path: "/me/shop/add-ons",
		},
		user.shop && {
			name: "Shop Sales",
			path: "/me/shop/orders"
		},
		{
			name: "spacer",
		},
		{
			name: "Introductions",
			path: "/me/introductions"
		}
	].filter(l => l) : [];

	return <div className="navigation">
		{links.map(link => link.name !== "spacer" ?
			(
				<NavLink
					exact
					className="link"
					key={link.path}
					to={link.path}
					activeClassName="current"
					onClick={onLinkClick ? onLinkClick : () => { }}
				>
					<img src={plus} alt="plus" />
					<span className="normalFont">{link.name}</span>
				</NavLink>
			) : (
				<div className="spacer" key={Math.random()}><br /></div>
			)
		)}
	</div>
}


